<div mat-dialog-content>
  <img [src]="src" stop-propagation (click)="onClose()">
</div>